<div class="header-logout col-sm-1">
  <section>
        
    <div class="header-content">
      <app-notification></app-notification>

        <a   href="#"  matTooltip="Logout" extended (click)="logout()" href="#">  <mat-icon class="logoutIcon" >power_settings_new</mat-icon>
        </a>
        
      </div>
   </section>
   
</div>